import { lineXYLength, projectPointOntoLineInXY, XY_LINE_LENGTH_EPSILON } from '@geometry'
import { ImmutableVector3 } from '@modugen/ui-toolkit'
import { roundImmutableVector3 } from 'src/geometry/rounding'
import { NUM_DECIMALS_ROUND_PURLIN_EDIT } from './constants'

type XYZ = { x: number; y: number; z: number }

export const flattenToXY = (point: XYZ): ImmutableVector3 =>
  new ImmutableVector3(point.x, point.y, 0)

export const hasUsablePurlinXYAxis = (start: XYZ, end: XYZ): boolean =>
  lineXYLength(start, end) >= XY_LINE_LENGTH_EPSILON

/**
 * Maps a 2D handle position onto the 3D purlin axis, rounds, then re-projects
 * so the committed point stays collinear with the original line.
 */
export const commitPurlinHandlePoint = (
  start: XYZ,
  end: XYZ,
  handlePoint: XYZ,
): ImmutableVector3 | null => {
  const projected = projectPointOntoLineInXY(start, end, handlePoint)
  if (!projected) return null

  const rounded = roundImmutableVector3(projected.projected, NUM_DECIMALS_ROUND_PURLIN_EDIT)
  const collinear = projectPointOntoLineInXY(start, end, rounded)

  return collinear?.projected ?? projected.projected
}
